__turbopack_context__.v({
  "arrow": "CCPqya_arrow",
  "children": "CCPqya_children",
  "container": "CCPqya_container",
  "isVisible": "CCPqya_isVisible",
  "opened": "CCPqya_opened",
});
